import type * as Sentry from "@sentry/react";

import { isApolloLikeError } from "./apolloError";

export const setSentryScope = (scope: Sentry.Scope, error: unknown) => {
  if (!isApolloLikeError(error)) return;

  // Group `Failed to fetch` errors (likely Hasura downtime)
  if (error instanceof Error && error.message === "Failed to fetch") {
    scope.setFingerprint(["apollo:failedToFetch"]);
  }

  scope.setContext("apollo", {
    graphQLErrors: error.graphQLErrors && error.graphQLErrors.length ? JSON.stringify(error.graphQLErrors) : null,
    protocolErrors: error.protocolErrors && error.protocolErrors.length ? JSON.stringify(error.protocolErrors) : null,
    clientErrors: error.clientErrors && error.clientErrors.length ? JSON.stringify(error.clientErrors) : null,
    networkError: error.networkError ?? null,
  });
};
